// extracted by mini-css-extract-plugin
module.exports = {"campusVideo":"campusvideo_campusVideo__y9MV9","videoBg":"campusvideo_videoBg___Zgf_"};